var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "white",
    cx: 32.003,
    cy: 32.005,
    r: 16.001
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.001,31.997c0-2.211-1.789-4-4-4H4c-2.211,0-4,1.789-4,4       s1.789,4,4,4h4C10.212,35.997,12.001,34.208,12.001,31.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.204,46.139l-2.832,2.833c-1.563,1.562-1.563,4.094,0,5.656       c1.562,1.562,4.094,1.562,5.657,0l2.833-2.832c1.562-1.562,1.562-4.095,0-5.657C16.298,44.576,13.767,44.576,12.204,46.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M32.003,51.999c-2.211,0-4,1.789-4,4V60c0,2.211,1.789,4,4,4       s4-1.789,4-4l-0.004-4.001C36.003,53.788,34.21,51.999,32.003,51.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M51.798,46.143c-1.559-1.566-4.091-1.566-5.653-0.004       s-1.562,4.095,0,5.657l2.829,2.828c1.562,1.57,4.094,1.562,5.656,0s1.566-4.09,0-5.656L51.798,46.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M60.006,27.997l-4.009,0.008       c-2.203-0.008-3.992,1.781-3.992,3.992c-0.008,2.211,1.789,4,3.992,4h4.001c2.219,0.008,4-1.789,4-4       C64.002,29.79,62.217,27.997,60.006,27.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M51.798,17.859l2.828-2.829c1.574-1.566,1.562-4.094,0-5.657       c-1.559-1.567-4.09-1.567-5.652-0.004l-2.829,2.836c-1.562,1.555-1.562,4.086,0,5.649C47.699,19.426,50.239,19.418,51.798,17.859z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M32.003,11.995c2.207,0.016,4-1.789,4-3.992v-4       c0-2.219-1.789-4-4-4c-2.211-0.008-4,1.781-4,3.993l0.008,4.008C28.003,10.206,29.792,11.995,32.003,11.995z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M12.212,17.855c1.555,1.562,4.079,1.562,5.646-0.004       c1.574-1.551,1.566-4.09,0.008-5.649l-2.829-2.828c-1.57-1.571-4.094-1.559-5.657,0c-1.575,1.559-1.575,4.09-0.012,5.653       L12.212,17.855z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.d32b0c2722347f7e3c6d02dc506432c7.svg";
export { ForwardRef as ReactComponent };